// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"8ec9641f","128":"adc984d5","150":"330d9967","592":"ee7bcd77"}[chunkId] + ".chunk.js";
};